import { jsx } from '@amazon/vinyl-tsx'
import { startSignIn } from '@/metrics/startSignIn'
import { Icon } from '@/components/Icon'
import { marketplace$ } from '@/marketplace'
import { hostTerritory, musicPlanSettingsUrl } from '@/territory'
import { getString } from '@/auth/i18n/bundle.generated'

// The landing stands in for GH's auth wall, the prompt a signed-out visitor meets at a gated surface.
const SIGN_IN_WALL_CONTENT_NAME = 'authWallModal'

/**
 * Signed-out landing page. Rendered by the router for gated routes (home,
 * chat) when the current session isn't signed in. Presents a hero mark, a
 * short benefits list, and a single primary CTA that kicks off the auth
 * handshake.
 */
export function SignInWall() {
    return (
        <div className="signInWall" aria-label={getString('dmusic_sign_in_wall_aria_label')}>
            <div className="signInWallHero" aria-hidden="true">
                <Icon icon="amazonMusic" className="signInWallHeroIcon" />
            </div>
            <h1 className="signInWallTitle">{getString('dmusic_sign_in_wall_title')}</h1>
            <p className="signInWallSubtitle">{getString('dmusic_sign_in_wall_subtitle')}</p>
            <ul className="signInWallBenefits">
                <li className="signInWallBenefit">
                    {getString('dmusic_sign_in_wall_benefit_recommendations')}
                </li>
                <li className="signInWallBenefit">
                    {getString('dmusic_sign_in_wall_benefit_library')}
                </li>
                <li className="signInWallBenefit">
                    {getString('dmusic_sign_in_wall_benefit_chat')}
                </li>
            </ul>
            <button
                className="textButton signInWallCta"
                onclick={() => startSignIn(SIGN_IN_WALL_CONTENT_NAME)}
            >
                {getString('dmusic_sign_in_wall_cta')}
            </button>
            <a
                className="textLink signInWallShowPlans"
                href={marketplace$.map((m) =>
                    musicPlanSettingsUrl(m?.musicTerritory ?? hostTerritory())
                )}
                target="_blank"
                rel="noopener noreferrer"
            >
                {getString('dmusic_sign_in_wall_show_plans')}
            </a>
        </div>
    )
}
